module.exports = __webpack_public_path__ + "img/39.928e6652.png";